import React, {Fragment} from 'react';
import classnames from 'classnames';
import {Container} from './style';
import FilterItem from './FilterItem';
import SortItem from './SortItem';
import LocationItem from './LocationItem';
import ClassifyItem from './ClassifyItem';
import MoreItem from './MoreItem';
import {Mask} from '@jdcfe/yep-react';
import unit_institution from "../../../store/asset_institution/unit_institution";
import { MpingClick,getBusinessTypeByMP } from '../../../utils/tool';

class InvestorsRecruitFilterBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fixed: false,
      currFilterItem: -1,
      currFilterItems: ['', '', '', ''],
      adaptationTop: '',
    };
    this.scrollListener = this.scrollListener.bind(this)
  }

  FilterItems = ['默认排序', '类型', '所在地', '更多'];

  scrollStatus = true;

  componentDidMount() {
    const {sticky} = this.props;

    if (sticky) {
      window.addEventListener('scroll', this.scrollListener)
    }

    const {store} = this.props;
    if (store.currFilterItems) {
      this.setState({
        currFilterItems: store.currFilterItems
      })
    }
  }
  componentWillUnmount() {
    const {sticky} = this.props;

    if (sticky) {
      window.removeEventListener('scroll', this.scrollListener)
    }
  }

  // 滚动监听
  scrollListener() {
    const {changeBlockStatus, adaptationTop, navHeight} = this.props;
    if (!adaptationTop) return;
    const scrollY = window.pageYOffset + navHeight - (unit_institution.zhiBoFloorClientHeight);
    if (this.scrollStatus && scrollY - adaptationTop >= 0) {
      this.setState({
        fixed: true,
      })
      changeBlockStatus(true);
    }

    if (this.scrollStatus && scrollY - adaptationTop < 0) {
      this.setState({
        fixed: false,
      })
      changeBlockStatus(false);
    }
  }

  changeCurrFilterItems = (index, name) => {
    // 筛选栏名称
    const {store} = this.props;
    let currFilterItems = this.state.currFilterItems;
    currFilterItems[index] = name;
    store.saveCurrData('currFilterItems', currFilterItems);
    this.setState({
      currFilterItems,
    })
  };

  clickHandle = (item) => {
    const {index} = item;
    const {currFilterItem} = this.state;
    const {sticky} = this.props;

    // 关闭
    if (index === currFilterItem) {
      this.setState({
        currFilterItem: -1,
      })
      this.scrollStatus = true;
    }

    // 打开
    if (index !== currFilterItem) {
      this.setState({
        currFilterItem: index,
      })
      this.scrollStatus = false;
    }

    if (sticky) {
      this.fixedBar(index)
    }

    if(index===0){
      MpingClick("Auction_SorterClick",JSON.stringify({business_type:getBusinessTypeByMP()}))
    }else if(index===1){
      MpingClick("Auction_FilterCate",JSON.stringify({business_type:getBusinessTypeByMP()}))
    }else if(index===2){
      MpingClick("Auction_FilterLocation",JSON.stringify({business_type:getBusinessTypeByMP()}))
    }else if(index===3){
      MpingClick("Auction_FilterMore",JSON.stringify({business_type:getBusinessTypeByMP()}))
    }
  };

  fixedBar = (index) => {
    const {changeBlockStatus, adaptationTop, navHeight} = this.props;
    const {currFilterItem} = this.state;
    const scrollY = window.pageYOffset + navHeight - (unit_institution.zhiBoFloorClientHeight);

    if (scrollY - adaptationTop < 0) {
      window.scrollTo(0, adaptationTop - navHeight);
      // 列表高度不够实现 fixed 直接添加 fixed 定位
      // scroll 事件会触发 fixed: false ,需要延迟执行
      setTimeout(() => {
        this.setState({
          fixed: true,
        })
        changeBlockStatus(true);
      }, 20)
    }

    if (index === currFilterItem) {
      if (scrollY - adaptationTop < 0) {
        // 关闭恢复定位
        this.setState({
          fixed: false,
        })
        changeBlockStatus(false);
      }

      if (scrollY - adaptationTop >= 0) {
        // 关闭恢复定位
        this.setState({
          fixed: true,
        })
        changeBlockStatus(true);
      }
    }
  }

  // 点击蒙层
  maskHandleClick = () => {
    const {changeBlockStatus, adaptationTop, navHeight} = this.props;
    const scrollY = window.pageYOffset + navHeight - (unit_institution.zhiBoFloorClientHeight);

    if (scrollY - adaptationTop < 0) {
      // 关闭恢复定位
      this.setState({
        fixed: false,
        currFilterItem: -1,
      })
      changeBlockStatus(false);
    }

    if (scrollY - adaptationTop >= 0) {
      // 关闭恢复定位
      this.setState({
        fixed: true,
        currFilterItem: -1,
      })
      changeBlockStatus(true);
    }
    this.scrollStatus = true;
  };

  closeFilter = () => {
    const {adaptationTop, navHeight} = this.props;
    this.setState({
      currFilterItem: -1,
    }, () => {
      window.scrollTo(0, adaptationTop - navHeight);
      this.scrollStatus = true;
    })
  }

  renderConditionItem() {
    const {currFilterItem} = this.state;
    const {store} = this.props;
    switch (currFilterItem) {
      case 0:
        return (<SortItem
          store={store}
          defaultIndex={currFilterItem}
          closeFilter={this.closeFilter}
          changeCurrFilterItems={this.changeCurrFilterItems}
        ></SortItem>);
        break;
      case 1:
        return (<ClassifyItem
          store={store}
          defaultIndex={currFilterItem}
          closeFilter={this.closeFilter}
          changeCurrFilterItems={this.changeCurrFilterItems}
        ></ClassifyItem>);
        break;
      case 2:
        return (<LocationItem
          store={store}
          defaultIndex={currFilterItem}
          closeFilter={this.closeFilter}
          changeCurrFilterItems={this.changeCurrFilterItems}
        ></LocationItem>);
        break;
      case 3:
        return (<MoreItem
          store={store}
          defaultIndex={currFilterItem}
          closeFilter={this.closeFilter}
          changeCurrFilterItems={this.changeCurrFilterItems}
        ></MoreItem>);
        break;
      default:
        return null;
        break;
    }
  }

  render() {
    const {currFilterItem, currFilterItems, fixed} = this.state;
    const {curTabIndex} = unit_institution;
    const {
      navHeight
    } = this.props;
    return (
      <Fragment>
        {currFilterItem != -1 && <Mask onClick={this.maskHandleClick}/>}
        <Container
          ref={(node) => this.filterContainer = node}
          className={classnames({'fixed': fixed && curTabIndex === 2})}
          style={{top: fixed ? `${navHeight}px` : 0}}
        >
          {
            this.FilterItems.map(
              (value, index) => {
                return (
                  <FilterItem
                    key={value}
                    fixedBar={this.fixedBar}
                    currIndex={currFilterItem}
                    defaultParam={value}
                    changeParam={currFilterItems[index]}
                    defaultIndex={index}
                    clickHandle={this.clickHandle}
                  ></FilterItem>
                )
              }
            )
          }
          <div className="condition-item" id="promotionCondition">
            {this.renderConditionItem()}
          </div>
        </Container>
      </Fragment>
    );
  }
}

export default InvestorsRecruitFilterBar;
